<template>
	<span class="truncated-text">
		<span v-html="wrapWords" />
	</span>
</template>

<script>
export default {
	name: 'TruncatedText',

	props: {
		text: {
			type: String,
			default: ''
		}
	},

	computed: {
		wrapWords() {
			return (
				this.text &&
				this.text.replace(
					/\w+/g,
					'<span class="truncated-text-chunk">$&</span>'
				)
			)
		}
	}
}
</script>

<style lang="scss">
.truncated-text {
	display: block;
	overflow: hidden;
}

.truncated-text-chunk {
	display: inline-block;
	vertical-align: top;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
